import clsx from "clsx";
import { HighlighterIcon } from "./HighlighterIcon";

export interface HighlightPanelToggleProps {
  /** Whether the panel is currently open */
  isOpen: boolean;
  /** Whether there are any active highlight selections */
  hasSelections: boolean;
  /** Toggle callback */
  onToggle: () => void;
  /** Optional tooltip/title */
  title?: string;
}

export default function HighlightPanelToggle({
  isOpen,
  hasSelections,
  onToggle,
  title = "Highlight options",
}: HighlightPanelToggleProps) {
  return (
    <button
      onClick={onToggle}
      className={clsx(
        "p-1 no-drag transition-all duration-200",
        // Menu open = solid fill
        isOpen && "bg-terminal-orange",
        // Active + closed = subtle indicator
        hasSelections && !isOpen && "bg-transparent",
        // Default = neutral
        !hasSelections &&
          !isOpen &&
          "bg-transparent hover:bg-gray-200 dark:hover:bg-gray-600"
      )}
      title={isOpen ? "Close highlights" : title}
    >
      <HighlighterIcon
        filled={hasSelections && !isOpen}
        className={clsx("size-4", {
          "text-white": isOpen,
          "text-terminal-orange": hasSelections && !isOpen,
          "text-gray-500 dark:text-gray-300": !hasSelections && !isOpen,
        })}
      />
    </button>
  );
}
